import {
  Component,
  OnInit,
  ViewChild,
  QueryList,
  ViewChildren,
  AfterViewInit,
  ElementRef,
  ChangeDetectorRef
} from "@angular/core";
import { TabOpenService } from "src/app/services/tab-open.service";
import { Tabs } from "src/app/enums/tab.enum";
import { TabContentComponent } from "@shared/tab/tab-content/tab-content.component";
import { DataSharing } from '@fs/services/data-sharing';
import { DataSharingLTE } from "@fs/services/data-sharing-lte";
import { PermissionPipe } from "@shared/pipes/permission";
import { ActionName } from "@shared/enums/action-name";
import { AuthService } from "@services/auth.service";
import { SpinnerService } from "../../services/spinner.service";
import { StatesService } from "../../services/states.service";
import { element, detectChanges } from "@angular/core/src/render3/instructions";
declare var initBodyCustomScroll;
@Component({
  selector: "app-tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.scss"]
})
export class TabsComponent implements OnInit, AfterViewInit {
  openedTabs: {
    tabId: number;
    params: any;
    active: boolean;
    tabTitle: string;
    uniqueRef: number;
    confirmPopup: boolean;
    destroyType: string;
    customClass:string;
  }[] = [];
  hiddenTabs: {
    tabId: number;
    params: any;
    active: boolean;
    tabTitle: string;
    uniqueRef: number;
    confirmPopup: boolean;
    destroyType: string;
  }[] = [];
  displayedTabs: {
    tabId: number;
    params: any;
    active: boolean;
    tabTitle: string;
    uniqueRef: number;
    confirmPopup: boolean;
    destroyType: string;
  }[] = [];
  refreshTabIds = [36,39];
  tabCounter: number = 1;
  ConfirmPopup: boolean = false;
  @ViewChild("tabs__link") tabUl: ElementRef;
  @ViewChildren("tabRef") tabRef: QueryList<TabContentComponent>;
  @ViewChildren("ellipseToolTip") ellipseToolTip: QueryList<
    TabContentComponent
  >;

  constructor(
    public tabOpen: TabOpenService,
    private permissionPipe: PermissionPipe,
    public det: ChangeDetectorRef,
    public dataSharing: DataSharing,
    public dataSharingLite: DataSharingLTE,
    public auth: AuthService,
    private showspinner: SpinnerService,
    private stateservice : StatesService
  ) {
    let myRef = this;
    window.onbeforeunload = function(ev) {
      if (
        myRef.openedTabs.length == 1 &&
        myRef.openedTabs[0].tabId == Tabs.Dashboard
      ) {
        // Do Nothing Condition
      } else if (myRef.openedTabs.length > 0) {
        ev.returnValue =
          "Data will be lost if you leave the page, are you sure?";
        return "Data will be lost if you leave the page, are you sure?";
      }
    };
    window.onpopstate = function() {
      if (
        myRef.openedTabs.length == 1 &&
        myRef.openedTabs[0].tabId == Tabs.Dashboard
      ) {
        // Do Nothing Condition
      } else if (myRef.openedTabs.length > 0) {
        return "Data will be lost if you leave the page, are you sure?";
      }
    };
    this.tabOpen.TabOpenEvent.subscribe(response => {
      if (response != null) { 
        $(".main__content_section").scrollTop(0);
        this.ShowTab(response);
      }
    });
    this.tabOpen.ReplaceTabEvent.subscribe(response => {
      if (response != null)
      $(".main__content_section").scrollTop(0);
        this.ReplaceTab(
          response.data.CurrentTabIndex,
          response.data.newTabInfo,
          response.checkDirty
        );
    });
    this.tabOpen.DestroyTabEvent.subscribe(response => {
      if (response != null)
        this.destroyTabConfirm(response.tabCounter, response.type);
    });
    //this.ShowTab({tabId:1,params:{},tabTitle:'New Customer'})

    this.tabOpen.UnsavedChangedDetected.subscribe(response => {
      const item = this.displayedTabs.find(
        x => x.uniqueRef == response.data.Index
      );
      if(item != undefined) {
        if (response.data.dirty) item.tabTitle = "* " + item.tabTitle;
        else {
          if (item.tabTitle.indexOf("*") != -1) {
            item.tabTitle = item.tabTitle.substr(1, item.tabTitle.length).trim();
          }
        }
        det.detectChanges();
      }
    });
    this.tabOpen.updateTabNameEvent.subscribe(res=>{
      if(res){
        const item = this.displayedTabs.find(
          x => x.uniqueRef == res.data.Index
        );
        if(item != undefined) {
          item.tabTitle=res.data.tabTitle;
        }

      }
    });
  }
  ngOnInit() {}
  OpenDashboard() {
    if (!this.permissionPipe.transform(ActionName.Dashboard)) {
      return;
    }
    this.tabOpen.OpenTab({
      tabId: Tabs.Dashboard,
      params: {},
      tabTitle: "Dashboard"
    });
  }
  onResize(event: any) {
    //to stop tab hiding on window resizing 
    window.scrollTo(0, 0);
    
    let width = $(this.tabUl.nativeElement).width();
    let counter = 1;
    while (
      this.displayedTabs.length > 1 &&
      this.displayedTabs.length * 180 + 32 > parseInt(width.toString())
    ) {
      if (
        this.displayedTabs[this.displayedTabs.length - counter].active == false
      ) {
        this.hiddenTabs.splice(
          0,
          0,
          this.displayedTabs[this.displayedTabs.length - counter]
        );
        this.displayedTabs.splice(this.displayedTabs.length - counter, 1);
      } else {
        counter = counter + 1;
      }
    }
    while (
      this.hiddenTabs.length > 0 &&
      (this.displayedTabs.length + 1) * 180 + 32 < parseInt(width.toString())
    ) {
      if (this.displayedTabs.length > 0) {
        if (this.displayedTabs[0].tabId == Tabs.Dashboard) {
          this.hiddenTabs[0].active = false;
          this.displayedTabs.push(this.hiddenTabs[0]);
          this.hiddenTabs.splice(0, 1);
        } else {
          var indexOfDashboard = this.hiddenTabs.findIndex(
            x => x.tabId == Tabs.Dashboard
          );
          this.hiddenTabs[indexOfDashboard].active = false;
          this.displayedTabs.splice(0, 0, this.hiddenTabs[indexOfDashboard]);
          this.hiddenTabs.splice(indexOfDashboard, 1);
        }
      }
    }
  }
  ngAfterViewInit() {
    let p = this.auth.getUserPlan();
    if (p != undefined && p != null && p != "p") {
      this.delay(5000);
      setTimeout(_ => this.OpenDashboard());
    }
  }
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  ReplaceTab(TabCounter, newTabInfo, checkDirty = true) {
    let tabAlreadyOpened = this.openedTabs.find(
      x =>
        x.tabId == newTabInfo.tabId &&
        (newTabInfo.params == null ||
          newTabInfo.params.ID == undefined ||
          x.params.ID === newTabInfo.params.ID)
    );
    if (tabAlreadyOpened == null) {
      // not already opened then push new tab
      let tabCloseAlert = false;
      this.tabRef.forEach(child => {
        if (child.tabCounter == TabCounter) {
          tabCloseAlert = $(
            child.viewContainerRef.element.nativeElement.nextSibling.firstChild
          ).hasClass("dirty");
        }
      });
      if (tabCloseAlert && checkDirty) {
        this.openedTabs.find(
          x => x.uniqueRef == TabCounter
        ).confirmPopup = true;
        this.openedTabs.find(x => x.uniqueRef == TabCounter).destroyType =
          "ReplaceTab";
        if (this.displayedTabs.find(x => x.uniqueRef == TabCounter) != null) {
          this.displayedTabs.find(
            x => x.uniqueRef == TabCounter
          ).confirmPopup = true;
          this.openedTabs.find(x => x.uniqueRef == TabCounter).destroyType =
            "ReplaceTab";
        }
        if (this.hiddenTabs.find(x => x.uniqueRef == TabCounter) != null) {
          this.hiddenTabs.find(
            x => x.uniqueRef == TabCounter
          ).confirmPopup = true;
          this.openedTabs.find(x => x.uniqueRef == TabCounter).destroyType =
            "ReplaceTab";
        }
        return;
      }
      else
      {
        this.tabOpen.ChangeComponentEvent.emit({ removeSubscriptions: true });
      }
      let index = this.openedTabs.findIndex(x => x.uniqueRef == TabCounter);
      let displayIndex = this.displayedTabs.findIndex(
        x => x.uniqueRef == TabCounter
      );
      let hiddenTabIndex = this.hiddenTabs.findIndex(
        x => x.uniqueRef == TabCounter
      );
      if (displayIndex > -1) {
        this.displayedTabs[displayIndex].params = newTabInfo.params;
        this.displayedTabs[displayIndex].tabId = newTabInfo.tabId;
        this.displayedTabs[displayIndex].tabTitle = newTabInfo.tabTitle;
      }
      if (hiddenTabIndex > -1) {
        this.hiddenTabs[hiddenTabIndex].params = newTabInfo.params;
        this.hiddenTabs[hiddenTabIndex].tabId = newTabInfo.tabId;
        this.hiddenTabs[hiddenTabIndex].tabTitle = newTabInfo.tabTitle;
      }
      this.openedTabs[index].params = newTabInfo.params;
      this.openedTabs[index].tabId = newTabInfo.tabId;
      this.openedTabs[index].tabTitle = newTabInfo.tabTitle;
      // initBodyCustomScroll.getScrollElement().scrollTop = 0
    } else {
      let currentTab = this.openedTabs.find(x => x.uniqueRef == TabCounter);
      if (
        (currentTab.tabId == Tabs.JobSiteDetail ||
          currentTab.tabId == Tabs.BillingDetail) &&
        newTabInfo.tabId == Tabs.JobSiteDetail
      ) {
        this.dataSharing.dropDownChangeEvent(TabCounter);
      }
      let tabCloseAlert = false;
      this.tabRef.forEach(child => {
        if (child.tabCounter == TabCounter) {
          tabCloseAlert = $(
            child.viewContainerRef.element.nativeElement.nextSibling.firstChild
          ).hasClass("dirty");
        }
      });
      if (tabCloseAlert && checkDirty) {
        this.openedTabs.find(
          x => x.uniqueRef == TabCounter
        ).confirmPopup = true;
        this.openedTabs.find(x => x.uniqueRef == TabCounter).destroyType =
          "ReplaceTab";
        if (this.displayedTabs.find(x => x.uniqueRef == TabCounter) != null) {
          this.displayedTabs.find(
            x => x.uniqueRef == TabCounter
          ).confirmPopup = true;
          this.openedTabs.find(x => x.uniqueRef == TabCounter).destroyType =
            "ReplaceTab";
        }
        if (this.hiddenTabs.find(x => x.uniqueRef == TabCounter) != null) {
          this.hiddenTabs.find(
            x => x.uniqueRef == TabCounter
          ).confirmPopup = true;
          this.openedTabs.find(x => x.uniqueRef == TabCounter).destroyType =
            "ReplaceTab";
        }
        return;
      }
      else
      {
        this.tabOpen.ChangeComponentEvent.emit({ removeSubscriptions: true });
      }
      this.focus(tabAlreadyOpened.uniqueRef);
    }
  }
  updateTabLinks(TabInfo: any) {
    let dropDownArrowWidth = (
      $(".dropdown.tabs__dropdown.ng-star-inserted").css("min-width") || "50px"
    ).replace(/[^0-9]/g, "");
    let availableWidth =
      $(this.tabUl.nativeElement).width() - parseFloat(dropDownArrowWidth);
    this.displayedTabs.forEach(element => {
      element.active = false;
    });
    let tabWidth =
      $(this.tabUl.nativeElement)
        .find("li.ng-star-inserted")
        .width() || 130;
    var tabLeftPadding =
      $(this.tabUl.nativeElement)
        .find("li.ng-star-inserted")
        .css("padding-left") || "10px";
    let tabRightPadding =
      $(this.tabUl.nativeElement)
        .find("li.ng-star-inserted")
        .css("padding-right") || "20px";
    let totalTabPadding =
      parseFloat(tabLeftPadding.replace(/[^0-9]/g, "")) +
      parseFloat(tabRightPadding.replace(/[^0-9]/g, ""));
    var requiredTabWidth = tabWidth + totalTabPadding;
    if (
      this.openedTabs.length * requiredTabWidth >
      parseFloat(availableWidth.toString())
    ) {
      this.hiddenTabs.splice(
        0,
        0,
        this.displayedTabs[this.displayedTabs.length - 1]
      );
      this.displayedTabs.splice(this.displayedTabs.length - 1, 1);
      this.displayedTabs.splice(
        this.TabLocationCheck(TabInfo.tabId),
        0,
        TabInfo
      );
    } else {
      this.displayedTabs.splice(
        this.TabLocationCheck(TabInfo.tabId),
        0,
        TabInfo
      );
    }
  }

  ngOnDestroy() {
    this.openedTabs = [];
  }

  // Show specific tab
  ShowTab(TabInfo: any) {
    this.openedTabs.forEach(element => {
      element.active = false;
    });
    let tabAlreadyOpened = this.openedTabs.find(
      x =>
        x.tabId == TabInfo.tabId &&
        (TabInfo.params == null ||
          TabInfo.params.ID == undefined ||
          x.params.ID === TabInfo.params.ID)
    );
    if (tabAlreadyOpened == null) {
      // not already opened then push new tab
      if (
        TabInfo.replaceIfOpen != undefined &&
        TabInfo.replaceIfOpen.replaceTab == true
      ) {
        this.replaceOpenedTab(TabInfo);
        return;
      }
      this.openedTabs.splice(this.TabLocationCheck(TabInfo.tabId), 0, {
        tabId: TabInfo.tabId,
        params: TabInfo.params,
        active: true,
        tabTitle: TabInfo.tabTitle,
        uniqueRef: this.tabCounter,
        confirmPopup: false,
        destroyType: "tab",
        customClass:""
      });
      this.updateTabLinks({
        tabId: TabInfo.tabId,
        params: TabInfo.params,
        active: true,
        tabTitle: TabInfo.tabTitle,
        uniqueRef: this.tabCounter
      });
      this.focus(this.tabCounter);
      this.tabCounter = this.tabCounter + 1; 
    } else {
      if (tabAlreadyOpened.tabId == Tabs.FsLiteSettingDashboard) {
        this.dataSharingLite.CloseSettingChildTabEvent.emit();
      }
      this.focus(tabAlreadyOpened.uniqueRef);
    }
  }

  replaceOpenedTab(TabInfo: any) {
    let tabAlreadyOpened = this.openedTabs.find(
      x =>
        x.tabId == TabInfo.replaceIfOpen.tabToReplace &&
        (TabInfo.params == null ||
          TabInfo.params.ID == undefined ||
          x.params.ID === TabInfo.params.ID)
    );
    if (tabAlreadyOpened == null) {
      this.openedTabs.splice(0, 0, {
        tabId: TabInfo.tabId,
        params: TabInfo.params,
        active: true,
        tabTitle: TabInfo.tabTitle,
        uniqueRef: this.tabCounter,
        confirmPopup: false,
        destroyType: "tab",
        customClass:""
      });
      this.updateTabLinks({
        tabId: TabInfo.tabId,
        params: TabInfo.params,
        active: true,
        tabTitle: TabInfo.tabTitle,
        uniqueRef: this.tabCounter
      });
      this.focus(this.tabCounter);
      this.tabCounter = this.tabCounter + 1;
    } else {
      if (TabInfo.replaceIfOpen.action == "replace") {
        this.ReplaceTab(tabAlreadyOpened.uniqueRef, TabInfo);
        this.focus(tabAlreadyOpened.uniqueRef);
      } else {
        this.focus(tabAlreadyOpened.uniqueRef);
      }
    }
  }
  foucsOnOpenedTabs(tabCounter: number) {
    let previousOpenedTab = this.openedTabs.find(e => e.active == true);
    let openedTab = this.openedTabs.find(e => e.uniqueRef == tabCounter);
    //If not focused then only give focus to the tab
    if(openedTab != null && !openedTab.active) {
      if(previousOpenedTab != undefined && previousOpenedTab != null)
      {
        let previousOpenTabTabId = previousOpenedTab.uniqueRef;
        this.focus(tabCounter,previousOpenTabTabId);
      }
      else
      {
        this.focus(tabCounter);
      }      
      //this.refreshTab(openedTab.tabId);
    }
  }
  focus(tabCounter: number,previousOpenedTab: number = -99) {
    this.tabOpen.focusTab(tabCounter,previousOpenedTab);
    this.openedTabs.forEach(element => {
      if (tabCounter == element.uniqueRef) 
      {
        element.active = true;
        setTimeout(() => {
          element.customClass="loadDelay";
        }, 1000);
      }
      else element.active = false;
    });
    if (this.displayedTabs.findIndex(x => x.uniqueRef == tabCounter) == -1) {
      this.hiddenTabs.splice(
        0,
        0,
        this.displayedTabs[this.displayedTabs.length - 1]
      );
      let tabindex = this.hiddenTabs.findIndex(x => x.uniqueRef == tabCounter);
      this.displayedTabs.splice(this.displayedTabs.length - 1, 1);
      this.displayedTabs.splice(1, 0, this.hiddenTabs[tabindex]); // 0 is fixed for dashboard
      this.hiddenTabs.splice(tabindex, 1);
    }
    this.displayedTabs.forEach(element => {
      if (tabCounter == element.uniqueRef) element.active = true;
      else element.active = false;
    });
    let index = this.displayedTabs.findIndex(x => x.uniqueRef == tabCounter);   
    if (<any>this.ellipseToolTip.toArray()[index] != undefined) {
      setTimeout(() => {
        let width = $((<any>this.ellipseToolTip.toArray()[index]).nativeElement)
          .find("label")
          .width();
        if (width > 138) {
          $((<any>this.ellipseToolTip.toArray()[index]).nativeElement).attr(
            "title",
            this.displayedTabs[index].tabTitle
          );
        }
      }, 300);
    }    
    // initBodyCustomScroll.getScrollElement().scrollTop = 0
  }  
  cancelDestroy() {
    let tabCounter = this.openedTabs.find(x => x.active).uniqueRef;
    this.openedTabs.find(x => x.uniqueRef == tabCounter).confirmPopup = false;
    if (this.displayedTabs.find(x => x.uniqueRef == tabCounter) != null) {
      this.displayedTabs.find(
        x => x.uniqueRef == tabCounter
      ).confirmPopup = false;
    }
    if (this.hiddenTabs.find(x => x.uniqueRef == tabCounter) != null) {
      this.hiddenTabs.find(x => x.uniqueRef == tabCounter).confirmPopup = false;
    }
  }
  saveandclose() {
    let tabCounter = this.openedTabs.find(x => x.active).uniqueRef;
    this.openedTabs.find(x => x.uniqueRef == tabCounter).confirmPopup = false;
    if (this.displayedTabs.find(x => x.uniqueRef == tabCounter) != null) {
      this.displayedTabs.find(
        x => x.uniqueRef == tabCounter
      ).confirmPopup = false;
    }
    if (this.hiddenTabs.find(x => x.uniqueRef == tabCounter) != null) {
      this.hiddenTabs.find(x => x.uniqueRef == tabCounter).confirmPopup = false;
    }
    if (
      this.openedTabs.find(x => x.uniqueRef == tabCounter).destroyType == "tab"
    )
      this.tabOpen.ConfirmDestroyTab({ tabCounter: tabCounter });
    else if (
      this.openedTabs.find(x => x.uniqueRef == tabCounter).destroyType == "link"
    )
      this.tabOpen.routeToParent({ tabCounter: tabCounter, event: "save" });
    else if (
      this.openedTabs.find(x => x.uniqueRef == tabCounter).destroyType ==
      "ReplaceTab"
    ) {
      //this.tabOpen.routeToParent({ tabCounter: tabCounter, event: "destroy" })
      this.tabOpen.routeToParent({
        tabCounter: tabCounter,
        event: "replaceTab|save"
      });
    } else this.tabOpen.destroyModal({ tabCounter: tabCounter, event: "save" });
  }
  discardChanges() {
    let tabCounter = this.openedTabs.find(x => x.active).uniqueRef;
    this.openedTabs.find(x => x.uniqueRef == tabCounter).confirmPopup = false;
    if (this.displayedTabs.find(x => x.uniqueRef == tabCounter) != null) {
      this.displayedTabs.find(
        x => x.uniqueRef == tabCounter
      ).confirmPopup = false;
    }
    if (this.hiddenTabs.find(x => x.uniqueRef == tabCounter) != null) {
      this.hiddenTabs.find(x => x.uniqueRef == tabCounter).confirmPopup = false;
    }
    if (
      this.openedTabs.find(x => x.uniqueRef == tabCounter).destroyType == "tab"
    )
      this.destroyTab(tabCounter);
    else if (
      this.openedTabs.find(x => x.uniqueRef == tabCounter).destroyType == "link"
    )
      this.tabOpen.routeToParent({ tabCounter: tabCounter, event: "destroy" });
    else if (
      this.openedTabs.find(x => x.uniqueRef == tabCounter).destroyType ==
      "ReplaceTab"
    ) {
      //this.tabOpen.routeToParent({ tabCounter: tabCounter, event: "destroy" })
      this.tabOpen.routeToParent({
        tabCounter: tabCounter,
        event: "replaceTab|discard"
      });
    } else
      this.tabOpen.destroyModal({ tabCounter: tabCounter, event: "destroy" });
  }
  destroyTabConfirm(tabCounter: number, type) {
    let tabCloseAlert = false;
    let tabPopupAlert=false;
    this.tabRef.forEach(child => {
      if (child.tabCounter == tabCounter) {
        //#region Clear Spinner Data for particular tab
        this.showspinner.ClearTabData(tabCounter);
        this.stateservice.deleteAdvanceFilterData(tabCounter);
        //#endregion
          if (child.tabId == Tabs.FsLiteImportData || child.tabId == Tabs.FsLiteReportsDashboard) {
          if(type=="closeTab"){
            tabPopupAlert=false;
            type="tab";
          }
          else{
             tabPopupAlert=true;
          }      
        }
        tabCloseAlert = $(
          child.viewContainerRef.element.nativeElement.nextSibling.firstChild
        ).hasClass("dirty");
      }
    });
    if (tabCloseAlert) {
      this.openedTabs.find(x => x.uniqueRef == tabCounter).confirmPopup = true;
      this.openedTabs.find(x => x.uniqueRef == tabCounter).destroyType = type;
      if (this.displayedTabs.find(x => x.uniqueRef == tabCounter) != null) {
        this.displayedTabs.find(
          x => x.uniqueRef == tabCounter
        ).confirmPopup = true;
        this.openedTabs.find(x => x.uniqueRef == tabCounter).destroyType = type;
      }
      if (this.hiddenTabs.find(x => x.uniqueRef == tabCounter) != null) {
        this.hiddenTabs.find(
          x => x.uniqueRef == tabCounter
        ).confirmPopup = true;
        this.openedTabs.find(x => x.uniqueRef == tabCounter).destroyType = type;
      }
    }
    else if(tabPopupAlert){
      this.tabOpen.alertPopup(tabCounter);
    }
    else if (type == "tab") {
      this.destroyTab(tabCounter);
      this.tabOpen.ChangeComponentEvent.emit({ removeSubscriptions: true });
    }
  }
  // destroy opened tab
  destroyTab(tabCounter: number) {
    let index = this.openedTabs.findIndex(x => x.uniqueRef == tabCounter);
    let displayIndex = this.displayedTabs.findIndex(
      x => x.uniqueRef == tabCounter
    );
    if (this.displayedTabs[displayIndex].tabId != Tabs.Dashboard) {
      let changeActiveTab = this.openedTabs[index].active;
      this.openedTabs.splice(index, 1);
      this.displayedTabs.splice(displayIndex, 1);
      if (this.hiddenTabs.length > 0) {
        this.hiddenTabs[0].active = false;
        this.displayedTabs.push(this.hiddenTabs[0]);
        this.hiddenTabs.splice(0, 1);
      }
      if (changeActiveTab && this.openedTabs.length > 0) {
        if (displayIndex >= this.displayedTabs.length) {
        if (displayIndex != 0)
        {
          this.focus(this.displayedTabs[displayIndex - 1].uniqueRef);
          //this.refreshTab(this.displayedTabs[displayIndex - 1].tabId);
        }
        } else 
        {
          this.focus(this.displayedTabs[displayIndex].uniqueRef);
          //this.refreshTab(this.displayedTabs[displayIndex].tabId);
        }       
      }
    }
    $("body").trigger("click");
  }
  TabLocationCheck(TabId: number) {
    var tablocation =
      TabId == null || TabId == undefined || TabId == Tabs.Dashboard ? 0 : 1; // fixed 0 index location for dashboard
    return tablocation;
  }
}
